import axios from "axios";

const httpClient = axios.create({
  //baseURL: 'http://127.0.0.1:8080',
  baseURL: "https://7g1r2ya83a.execute-api.eu-central-1.amazonaws.com/Prod",
  headers: {
    "Content-Type": "application/json",
  },
});

export default httpClient;
